import { Component, OnInit } from '@angular/core';

import { pessoasModuleName } from "../shared/data.service";
import { Pessoa } from "../shared/pessoa.model";
import { PessoaApiService } from "../shared/pessoa-api.service";
import { PessoaNavigationService } from "../shared/pessoa-navigation.service";
import { UtilService } from "../../../shared/services/util.service";

@Component({
  template: require('./pessoa-list.component.html'),
  styles: [require('./pessoa-list.component.css')]
})
export class PessoaListComponent implements OnInit {
  list: Pessoa[] = [];
  loading: boolean = true;
  showDisabled: boolean = false;
  pessoasModuleName: any = pessoasModuleName;

  constructor(
    private _pessoasApiService: PessoaApiService,
    private _pessoaNavigationService: PessoaNavigationService,
    private _utilService: UtilService
  ) { }

  ngOnInit() {
    this.getAll();
  }

  clickNew() {
    this._pessoaNavigationService.goToNew();
  }

  clickEdit(item: Pessoa) {
    this._pessoaNavigationService.goToEdit(item.id);
  }

  clickDelete(item: Pessoa) {
    var onDelete = (function() {
      this.onDelete(item);
    }.bind(this));

    this._utilService.swalMessageDelete(onDelete);
  }

  private getAll() {
    var onDone = (function(Response: any) {
      if (!Response.error)  {
        this.list = Response;
      }
      this.loading = false;
    }.bind(this));

    this._pessoasApiService.onGetAll(onDone);
  }

  private onDelete(item: any) {
    var onDone = (function(Response: any) {
      if (!Response.error)  {
        var x: number, lenX: number;
        for (x = 0, lenX = this.list.length; x < lenX; x++) {
          if (this.list[x].id === item.id) {
            this.list[x].ativo = false;
            break;
          }
        }
        this._utilService.swalMessageDeleteSuccess();
      } else {
        this._utilService.swalMessageDeleteError();
      }
    }.bind(this));

    this._pessoasApiService.onDelete(item.id, onDone);
  }
}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/recursos-humanos/pessoas/pessoa-list/pessoa-list.component.ts
 **/